"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const material_ui_confirm_1 = require("material-ui-confirm");
const data_1 = require("@@/assets/data");
const svgs_1 = require("@@/assets/svgs");
const functions_1 = require("@/common/functions");
const Autocomplete_1 = __importDefault(require("@mui/material/Autocomplete"));
const TextField_1 = __importDefault(require("@mui/material/TextField"));
const Box_1 = __importDefault(require("@mui/material/Box"));
function default_1({ setCountryPhoneCode, countryPhoneCode, disabled, notChange, }) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const confirm = (0, material_ui_confirm_1.useConfirm)();
    const currentRegionCodeObj = data_1.countryRegionCode.find(obj => obj.code === countryPhoneCode);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: currentRegionCodeObj && ((0, jsx_runtime_1.jsxs)("div", Object.assign({ css: {
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                '.MuiAutocomplete-listbox': {
                    fontSize: '15px',
                    ".MuiAutocomplete-option[aria-selected='true']": {
                        backgroundColor: '#F8F8F8 !important',
                    },
                },
                '.MuiAutocomplete-noOptions': {
                    fontSize: '15px',
                    color: 'rgba(0, 0, 0, 0.3)',
                },
                '.MuiAutocomplete-paper': {
                    height: '200px',
                    '> ul': { height: '200px' },
                },
            } }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ css: {
                        position: 'absolute',
                        left: '10px',
                        display: 'flex',
                        width: '20px',
                        '&:after': (0, functions_1.afterImgWrapper)({ borderRadius: '2px' }),
                    } }, { children: (0, jsx_runtime_1.jsx)("img", { loading: "lazy", css: { width: '100%', borderRadius: '2px' }, alt: currentRegionCodeObj.region, src: `https://flagcdn.com/w20/${currentRegionCodeObj.region.toLowerCase()}.png`, srcSet: `https://flagcdn.com/w40/${currentRegionCodeObj.region.toLowerCase()}.png 2x` }) })), (0, jsx_runtime_1.jsx)(Autocomplete_1.default, { onChange: (_, value) => {
                        if (!notChange) {
                            if (!disabled) {
                                setCountryPhoneCode(value.code);
                            }
                        }
                        else {
                            confirm({
                                description: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [t('대한민국에서 해외로 휴대폰 변경 할 수 없어요.'), (0, jsx_runtime_1.jsx)("br", {}), t('도움이 필요하면 1:1문의해주세요!')] })),
                                confirmationText: t('확인'),
                                cancellationButtonProps: { style: { display: 'none' } },
                                allowClose: false,
                            });
                        }
                    }, disabled: disabled, sx: {
                        display: 'flex',
                        width: '95px',
                        height: '48px',
                        border: '1px solid rgba(0, 0, 0, 0.1)',
                        borderRadius: '8px',
                        backgroundColor: disabled ? '#F8F8F8' : 'white',
                    }, popupIcon: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: !disabled && (0, jsx_runtime_1.jsx)(svgs_1.ChevronDownSvg, { css: { width: '20px', height: '20px' } }) }), value: currentRegionCodeObj, options: data_1.countryRegionCode, autoHighlight: true, disableClearable: true, disablePortal: true, autoComplete: true, noOptionsText: t('결과 없음'), getOptionLabel: option => option.code, renderOption: (props, option) => ((0, jsx_runtime_1.jsxs)(Box_1.default, Object.assign({ component: "li", sx: { '& > img': { mr: 2, flexShrink: 0, border: '1px solid var(--gray-10)' } } }, props, { children: [(0, jsx_runtime_1.jsx)("img", { loading: "lazy", width: "20px", alt: option.region, src: `https://flagcdn.com/w20/${option.region.toLowerCase()}.png`, srcSet: `https://flagcdn.com/w40/${option.region.toLowerCase()}.png 2x` }), "+", option.code] }))), renderInput: params => ((0, jsx_runtime_1.jsx)(TextField_1.default, Object.assign({ type: "tel", sx: {
                            display: 'flex',
                            flexDirection: 'row',
                            '.MuiInput-root': {
                                display: 'flex',
                                alignItems: 'center',
                                p: '8px 34px',
                            },
                            '.MuiInput-input': {
                                display: 'flex',
                                alignItems: 'center',
                                textAlign: 'center',
                                p: '0 !important',
                                fontSize: '15px',
                                lineHeight: '20px',
                                color: 'var(--gray-80)',
                                ':disabled': {
                                    opacity: 1,
                                    WebkitTextFillColor: 'var(--gray-80)',
                                },
                            },
                            '.MuiAutocomplete-endAdornment': {
                                position: 'absolute',
                                top: 'unset',
                                right: '6px',
                                transform: 'translate(0, 0)',
                                '> button': {
                                    padding: 0,
                                },
                            },
                        }, variant: "standard" }, params))) })] }))) }));
}
exports.default = default_1;
